import dayjs from "dayjs";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "ID",
    model: "id",
    required: true,
    readonly: true,
    visible: (model) => model.id
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '名稱',
    model: 'name',
    placeholder: '名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "頭像圖片",
    help: "寬：1030 px, 高：450 px",
    model: "icon_path",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "staff_links",
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '識別鍵',
    model: 'key',
    placeholder: '識別鍵',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "網址",
    model: "url",
    placeholder: "請輸入網址",
    labelRemark: '請輸入連結 (如：https://) ',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '是否啟用',
    model: 'is_enabled',
    required: true,
    textOn: '啟用',
    textOff: '停用',
    valueOn: 1,
    valueOff: 0,
  },
];

export default fields;
